import React from 'react';

const About = () => {
  return (
    <div style={{
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '20px',
      fontFamily: 'Arial, sans-serif',
      lineHeight: '1.6',
      color: '#333'
    }}>
      {/* SEO Header */}
      <div style={{
        textAlign: 'center',
        marginBottom: '40px',
        padding: '40px 20px',
        backgroundColor: 'white',
        borderRadius: '12px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
      }}>
        <h1 style={{
          fontSize: '36px',
          fontWeight: 'bold',
          color: '#dc2626',
          marginBottom: '16px'
        }}>
          About Wheel of Names - The Ultimate Random Name Picker
        </h1>
        <p style={{
          fontSize: '18px',
          color: '#666',
          maxWidth: '800px',
          margin: '0 auto'
        }}>
          Discover the story behind the most trusted <strong>random name generator</strong> and <strong>decision maker tool</strong> used by millions worldwide.
        </p>
      </div>

      {/* Main Content Grid */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
        gap: '30px',
        marginBottom: '40px'
      }}>
        {/* Our Story */}
        <div style={{
          backgroundColor: 'white',
          padding: '30px',
          borderRadius: '12px',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
        }}>
          <h2 style={{
            fontSize: '24px',
            fontWeight: 'bold',
            color: '#dc2626',
            marginBottom: '16px'
          }}>
            🎯 Our Story
          </h2>
          <p style={{ marginBottom: '16px' }}>
            Wheel of Names was created with a simple mission: to make random selection fair, fun, and accessible to everyone. What started as a simple <strong>classroom name picker</strong> has evolved into the premier <strong>online spinner tool</strong> trusted by educators, streamers, and decision-makers worldwide.
          </p>
          <p>
            Our <strong>random name wheel</strong> has helped millions make unbiased decisions, from selecting students in classrooms to choosing winners in online giveaways. We believe that fairness should be simple, transparent, and engaging.
          </p>
        </div>

        {/* Why Choose Us */}
        <div style={{
          backgroundColor: 'white',
          padding: '30px',
          borderRadius: '12px',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
        }}>
          <h2 style={{
            fontSize: '24px',
            fontWeight: 'bold',
            color: '#dc2626',
            marginBottom: '16px'
          }}>
            ⭐ Why Educators Love Us
          </h2>
          <ul style={{
            listStyle: 'none',
            padding: '0'
          }}>
            <li style={{ marginBottom: '12px', paddingLeft: '20px', position: 'relative' }}>
              <span style={{ position: 'absolute', left: '0', color: '#dc2626' }}>✓</span>
              <strong>Fair Selection:</strong> Our <strong>student name randomizer</strong> ensures every student has an equal chance
            </li>
            <li style={{ marginBottom: '12px', paddingLeft: '20px', position: 'relative' }}>
              <span style={{ position: 'absolute', left: '0', color: '#dc2626' }}>✓</span>
              <strong>Engagement Tool:</strong> Increase classroom participation with our <strong>interactive spinner</strong>
            </li>
            <li style={{ marginBottom: '12px', paddingLeft: '20px', position: 'relative' }}>
              <span style={{ position: 'absolute', left: '0', color: '#dc2626' }}>✓</span>
              <strong>Time Saver:</strong> Quick setup means more time for teaching
            </li>
            <li style={{ marginBottom: '12px', paddingLeft: '20px', position: 'relative' }}>
              <span style={{ position: 'absolute', left: '0', color: '#dc2626' }}>✓</span>
              <strong>No Registration:</strong> Start using our <strong>free name picker</strong> immediately
            </li>
          </ul>
        </div>
      </div>

      {/* Features Section */}
      <div style={{
        backgroundColor: 'white',
        padding: '40px',
        borderRadius: '12px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        marginBottom: '40px'
      }}>
        <h2 style={{
          fontSize: '28px',
          fontWeight: 'bold',
          color: '#333',
          textAlign: 'center',
          marginBottom: '30px'
        }}>
          🚀 Advanced Features for Every User
        </h2>
        
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '25px'
        }}>
          <div style={{ textAlign: 'center' }}>
            <div style={{
              width: '60px',
              height: '60px',
              backgroundColor: '#dc2626',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 16px',
              fontSize: '24px'
            }}>
              🎨
            </div>
            <h3 style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '8px' }}>
              Customizable Design
            </h3>
            <p style={{ fontSize: '14px', color: '#666' }}>
              Personalize your <strong>name wheel generator</strong> with custom colors and styles
            </p>
          </div>

          <div style={{ textAlign: 'center' }}>
            <div style={{
              width: '60px',
              height: '60px',
              backgroundColor: '#dc2626',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 16px',
              fontSize: '24px'
            }}>
              📱
            </div>
            <h3 style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '8px' }}>
              Mobile Optimized
            </h3>
            <p style={{ fontSize: '14px', color: '#666' }}>
              Perfect <strong>mobile spinner</strong> experience on all devices and screen sizes
            </p>
          </div>

          <div style={{ textAlign: 'center' }}>
            <div style={{
              width: '60px',
              height: '60px',
              backgroundColor: '#dc2626',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 16px',
              fontSize: '24px'
            }}>
              ⚡
            </div>
            <h3 style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '8px' }}>
              Instant Results
            </h3>
            <p style={{ fontSize: '14px', color: '#666' }}>
              Lightning-fast <strong>random selection</strong> with smooth animations
            </p>
          </div>

          <div style={{ textAlign: 'center' }}>
            <div style={{
              width: '60px',
              height: '60px',
              backgroundColor: '#dc2626',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 16px',
              fontSize: '24px'
            }}>
              🔒
            </div>
            <h3 style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '8px' }}>
              Privacy Focused
            </h3>
            <p style={{ fontSize: '14px', color: '#666' }}>
              Your data stays private - no tracking, no storage, just pure <strong>random generation</strong>
            </p>
          </div>
        </div>
      </div>

      {/* Use Cases */}
      <div style={{
        backgroundColor: '#f8f9fa',
        padding: '40px',
        borderRadius: '12px',
        marginBottom: '40px'
      }}>
        <h2 style={{
          fontSize: '28px',
          fontWeight: 'bold',
          color: '#333',
          textAlign: 'center',
          marginBottom: '30px'
        }}>
          📚 Popular Use Cases
        </h2>
        
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '25px'
        }}>
          <div>
            <h3 style={{
              fontSize: '20px',
              fontWeight: 'bold',
              color: '#dc2626',
              marginBottom: '12px'
            }}>
              Education & Teaching
            </h3>
            <ul style={{ listStyle: 'none', padding: '0' }}>
              <li style={{ marginBottom: '8px', paddingLeft: '20px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#dc2626' }}>•</span>
                <strong>Classroom participation:</strong> Fair student selection for questions
              </li>
              <li style={{ marginBottom: '8px', paddingLeft: '20px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#dc2626' }}>•</span>
                <strong>Group formation:</strong> Random team assignments
              </li>
              <li style={{ marginBottom: '8px', paddingLeft: '20px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#dc2626' }}>•</span>
                <strong>Presentation order:</strong> Unbiased speaking sequence
              </li>
            </ul>
          </div>

          <div>
            <h3 style={{
              fontSize: '20px',
              fontWeight: 'bold',
              color: '#dc2626',
              marginBottom: '12px'
            }}>
              Events & Entertainment
            </h3>
            <ul style={{ listStyle: 'none', padding: '0' }}>
              <li style={{ marginBottom: '8px', paddingLeft: '20px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#dc2626' }}>•</span>
                <strong>Giveaways & contests:</strong> Fair winner selection
              </li>
              <li style={{ marginBottom: '8px', paddingLeft: '20px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#dc2626' }}>•</span>
                <strong>Party games:</strong> Fun decision making tool
              </li>
              <li style={{ marginBottom: '8px', paddingLeft: '20px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#dc2626' }}>•</span>
                <strong>Raffle drawings:</strong> Transparent prize distribution
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div style={{
        textAlign: 'center',
        padding: '40px',
        backgroundColor: '#dc2626',
        color: 'white',
        borderRadius: '12px'
      }}>
        <h2 style={{
          fontSize: '28px',
          fontWeight: 'bold',
          marginBottom: '16px'
        }}>
          Ready to Make Fair Decisions?
        </h2>
        <p style={{
          fontSize: '18px',
          marginBottom: '24px',
          opacity: '0.9'
        }}>
          Join millions who trust our <strong>random name picker</strong> for unbiased selections
        </p>
        <a 
          href="/"
          style={{
            display: 'inline-block',
            backgroundColor: 'white',
            color: '#dc2626',
            padding: '12px 30px',
            borderRadius: '25px',
            textDecoration: 'none',
            fontWeight: 'bold',
            fontSize: '18px'
          }}
        >
          Try Wheel of Names Now →
        </a>
      </div>
    </div>
  );
};

export default About;